export const THEME_SEIZE_COOKIE_KEY = 'themeSize'